namespace GeniuzPOS.Purchase {
    export class PoApprovalTranColumns {
        static columnsKey = 'Purchase.PoApprovalTran';
    }
}
